import React from 'react';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import _get from 'lodash/get';

import { NotSubscribedError } from '../errorPage';
import ReportThumb from './ReportThumb';
import './reports.css';
import { auth } from '../../utils/sessions';

class ReportCategory extends React.Component {
    componentDidMount(){
        auth.extend_or_expire();
    }

    componentWillReceiveProps() {
        auth.extend_or_expire();
    }

    render(){
        let redirectPath = null;
        const categoryId = _get(this, 'props.match.params.categoryId', null);
        const category = this.props.reportCategories.find(cat => cat.id === categoryId);

        if(!categoryId || !category){
            //redirect the user to the first category
            redirectPath = `/category/${this.props.reportCategories[0].id}`;

            return <Redirect to={{
                pathname: redirectPath
            }}/>
        }
        else if(auth.tab_disabled(this.props.user.ul, category.title)){
            return (
                <NotSubscribedError />
            )
        }
        else if(category.reports.length){
            return (
                <div className="row report-category">
                    {
                        category.reports.map((report) =>
                            <ReportThumb key={report.id} categoryId={category.id} report={report} />
                        )
                    }
                </div>
            )
        }
        else {
            return (
                <div className="coming-soon"> </div>
            )
        }
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        reportCategories: state.reportCategories
    };
}

export default withRouter(connect(mapStateToProps)(ReportCategory));


// WEBPACK FOOTER //
// ./src/components/reports/ReportCategory.jsx